<div class="crm-container">

  <app-section-header [title]="'User'" />

  <name-info [formFields]="nameInfo"></name-info><user-contact-info
    [formFields]="userContactInfo"></user-contact-info><user-name-info
    [formFields]="usernameInfo"></user-name-info><button class="crm-button" type="button"
    label="Create User Name">Create User Name</button>
</div>